<template>
<div class="container-fluid">

<spinner v-bind:spinner='spinner'></spinner>


<div class="card border border-primary  mb-3" style="max-width: 50rem;">
  <div class="card-header text-white bg-primary">
    
    <h4>
      
      <i style="color: yellow;" class="fas fa-edit mr-2" aria-hidden="true"></i>
      REGISTRAZIONE COMMISSIONE BASE </h4> </div>
    <div class="card-body">
    <h5 class="card-title"></h5>
    <form v-on:submit.prevent="saveData()">
    <div class="table-wrapper-scroll-y my-custom-scrollbar">              
    <table class="table table-sm table-hover mb-0" id="table">
      <thead >
        <tr class="table-primary">
          <th>
          # 
          </th>          
          <th>
              MARKET
          </th>
          <th>
              COMMISSIONE BASE
          </th>                        
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            {{index+1}}
          </td>
                
          <td>
          {{item.market}}
          </td>
        
          <td>

            <div class="input-group">
            <div class="input-group-prepend">
                          <div class="input-group-text ">%</div>
                      </div>
              <input required v-model = "item.commission" ref="'id_' + index " class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
            </div>          
          
          </td>
          
        </tr>
      </tbody>
    </table> 
    </div>

  <button :disabled="bt_spinner==true"   class="btn btn-primary float-right mr-3">
    <i style="color:yellow" class="fas fa-edit mr-2 " aria-hidden="true"></i>
    MODIFICA
  </button>
  </form>

  
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


</div>
</div>  
</div>

</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';

import spinner            from '@/components/common/Spinner.vue';
import alertBox           from '@/components/common/AlertBox.vue';

export default {
  props : ['item'],
   components: {
     spinner,alertBox
   
  },
  
  data () {
    return {


    msg            :{
      title        : ''
    }, 

    
    items          : [],
    bt_spinner     : false,
  
    spinner        : false
    

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),     

  },
      
  mounted()
  {
    

    this.getData()

  },
  created()  
  {

   
  }, 
  methods: 
    {
      
           
     async saveData()
      {
         
        this.msg.title = ''     
       

        this.bt_spinner = true          
        const data     = {
          'companyId' : this.company.Id,
           'body'     : this.items}
        const sp       = {'sp':'spUpdateMarketBasicCommission'}        
                                  
        const json     = Object.assign(data, sp)
              
        await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              

              this.msg.title = 'REGISTRAZIONE COMMISSIONE.'
              this.msg.body = 'Modifica effettuata.'
              this.msg.type = 0              
              
            }
           else if(res.status==500)
           {
                

              this.msg.title = 'ATTENZIONE ***'
              this.msg.body = res.data
              this.msg.type = 1                
                
                    
           } 
           else
            { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
          

          }).catch(err => {
              
              
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.nessage
              this.msg.type = 1                 

              
          }).finally(() => {
          this.bt_spinner = false
        });
        


        

      },
    
    
      
      async getData() 
      {


        this.spinner = true          
        const data     = {'companyId' : this.company.Id}
        const sp       = {'sp':'spMarketBasicCommission'}        
        
        const json     = Object.assign(data, sp)
        await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0] 
               this.$nextTick().then(function () {
              
                document.getElementById("id_0").focus();
                
               })     
            }
           else if(res.status==500)
           {
                

              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                
                    
           } 
           else
            { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
          

          }).catch(err => {
              
              
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.nessage
              this.msg.type = 1                 

              
          }).finally(() => {
          this.spinner = false
        });
        


        
    
        

      }
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 500px;
overflow : auto;
}
.table-wrapper-scroll-y {
  display  : block;
}
a{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  color       : red
}

.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }

    .bold
    {
        font-weight  : bold;
    }
    input[type=number] {
    border: 1px solid;
 
}
</style>